<template>
    <el-breadcrumb class="app-breadcrumb" separator="/">
        <transition-group name="breadcrumb">
            <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.name" v-if='item.name' :to="{name: item.path}" :replace="true">
                <span class="no-redirect">{{item.name}}</span>
            </el-breadcrumb-item>
        </transition-group>
    </el-breadcrumb>
</template>

<script>
    export default {
        created() {
            this.getBreadcrumb()
        },
        data() {
            return {
                levelList: null
            }
        },
        watch: {
            $route() {
                this.getBreadcrumb()
            }
        },
        computed: {},
        methods: {
            getBreadcrumb() {
                var names = this.$route.name.split("-");
                var bread = [];
                names.forEach((item, index) => {
                    let path = index !== 0 ? (bread[index - 1].path + '-' + item) : item
                    bread.push({name: item, path});
                })
                bread.unshift({path: '默认', name: this.$store.state.app.name});
                this.levelList = bread
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .app-breadcrumb.el-breadcrumb {
        display: inline-block;
        font-size: 14px;
        line-height: 50px;
        margin-left: 10px;
        .no-redirect {
            color: #97a8be;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue